import React, { useState } from 'react';
import fetchClient from 'interfaces/fetchClient';

interface ProductLabelsProps {
    products: any[];
    onClose: () => void;
}

const config = () => {
    return {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
    };
};

const ProductLabels: React.FC<ProductLabelsProps> = ({ products, onClose }) => {
    const [isGenerating, setIsGenerating] = useState(false);

    const handleGeneratePDF = async () => {
        setIsGenerating(true);
        try {
            const productIds = products.map(p => p._id || p.id).filter(Boolean);
            
            const response = await fetchClient.post(
                '/products/labels/generate',
                { productIds },
                { 
                    ...config(),
                    responseType: 'blob' 
                }
            );

            // Create download link
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const date = new Date().toISOString().split('T')[0];
            link.download = `etiquettes-produits-${date}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            // Close modal after download
            setTimeout(() => {
                onClose();
            }, 500);
        } catch (error) {
            console.error('Erreur lors de la génération du PDF:', error);
            alert('Erreur lors de la génération des étiquettes');
        } finally {
            setIsGenerating(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[9999]">
            <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative z-[10000]">
                <h2 className="text-gray-900 font-semibold text-xl mb-3">Générer les étiquettes</h2>
                <p className="text-gray-600 text-sm mb-6">
                    {products.length} produit{products.length > 1 ? 's' : ''} sélectionné{products.length > 1 ? 's' : ''}
                </p>
                
                <div className="flex gap-3">
                    <button
                        onClick={handleGeneratePDF}
                        disabled={isGenerating}
                        className={`linear flex-1 flex items-center justify-center rounded-xl px-4 py-3 text-base font-medium text-white transition duration-200 ${
                            isGenerating
                                ? 'cursor-not-allowed bg-gray-400 opacity-50'
                                : 'bg-toola-500 hover:bg-toola-600 active:bg-toola-700'
                        }`}
                    >
                        {isGenerating ? 'Génération en cours...' : 'Télécharger le PDF'}
                    </button>
                    <button
                        onClick={onClose}
                        disabled={isGenerating}
                        className="linear flex items-center justify-center rounded-xl border border-gray-300 px-4 py-3 text-base font-medium text-gray-700 transition duration-200 hover:bg-gray-50 active:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Annuler
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProductLabels;
